<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>教育经历</h1>
            </el-col>
            <el-col :span="20">
                <div class="resumeContent" v-for="(item,index) in resumeInfo.educationExperienceList">
                    <el-row>
                        <el-col :span="12">
                            <p><b>{{item.studyTime}} ~ {{item.graduationTime}}</b></p>
                        </el-col>
                        <el-col :span="12">
                            <p><b>{{item.educationalBackground}}</b></p>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <p>{{item.school}}</p>
                        </el-col>
                        <el-col :span="12">
                            <p>{{item.speciality}}</p>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: 'educationExperience',
        props: ['resumeInfo'],
        data () {
            return {
            }
        },
        computed: {
            // 简历教育经历列表数量
            educationExperienceSize(){
                return this.size();
            }
        },
        methods: {
            // 计算简历工作经历数量
            size(){
                var educationExperienceSize = 0;
                for(var i in this.resumeInfo.educationExperienceList) {
                    educationExperienceSize++;
                }
                return educationExperienceSize;
            },
        }
    }
</script>